"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentDetails_1 = require("./PaymentDetails");
exports.default = PaymentDetails_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/PaymentDetails/index.js
// module id = 76
// module chunks = 0 1